import React, {Component} from 'react';
import UserHomeTableTrans from './user-home-table-trans';

class UserHomeTableTransactions extends Component{

    componentDidMount() {
      }

    render(){

        return(


            <div className="tab-pane fade" id="transactions" role="tabpanel">
                <div className="transactions-tables">
                    <h2 className="transactions-title">المعاملات</h2>
                     <UserHomeTableTrans transDescription={"دراسة جدوى أولية"} transDate={"27/1/2021"} transTime={"3:15"} transID={"0258963147"} transQuantity={"12,000 ر.س"} transStatus={"جديدة"}/>
                     <UserHomeTableTrans transDescription={"دراسة جدوى أولية"} transDate={"27/1/2021"} transTime={"3:15"} transID={"0258963147"} transQuantity={"12,000 ر.س"} transStatus={"جديدة"}/>
                     <UserHomeTableTrans transDescription={"دراسة جدوى أولية"} transDate={"27/1/2021"} transTime={"3:15"} transID={"0258963147"} transQuantity={"12,000 ر.س"} transStatus={"جديدة"}/>
                </div>
                <div className="text-center">
                    <a className="get-start-btn red-btn" href="/about">طباعة</a>
                </div>
        </div>
            
        );
       
    }

};
export default UserHomeTableTransactions;


